"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChipContainer = exports.Chip = exports.Icon = exports.Item = exports.Link = exports.Subtitle = exports.Paragraph = exports.Slide = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const core_1 = require("@material-ui/core");
const atoms_1 = require("../../atoms");
exports.Slide = (0, styled_components_1.default)(core_1.Slide) `
  flex-shrink: 0;
  white-space: 'nowrap';
`;
exports.Paragraph = (0, styled_components_1.default)(core_1.Typography) `
  font-size: 16px;
  font-family: 'ATTAleckSansMd';
`;
exports.Subtitle = (0, styled_components_1.default)(core_1.Typography) `
  font-size: 12px;
  font-family: 'ATTAleckSansMd';
  font-weight: bold;
`;
exports.Link = (0, styled_components_1.default)(core_1.Button) `
  background-color: white;
  padding: 0;
  border-width: 0;
  min-width: fit-content;

  .MuiButton-label {
    color: black;
    font-size: 12px;
    font-weight: normal;
    font-family: 'ATTAleckSansMd';
    text-transform: none;
    text-decoration: underline;
  }
`;
exports.Item = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
`;
exports.Icon = (0, styled_components_1.default)(atoms_1.Icon) `
  height: fit-content;
`;
exports.Chip = (0, styled_components_1.default)(core_1.Chip) `
  height: 25px;
  background-color: #f5f5f5;

  .MuiChip-label {
    padding-left: 8px;
    color: black;
    min-width: 50px;
  }
`;
exports.ChipContainer = styled_components_1.default.div `
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 9px;
`;
